

<template>
  <ams-thumbnail
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :ams_template="ams_template"
    :reroute_name="reroute_name"
  />
</template>

<script>
import AmsThumbnail from './AmsThumbnail.vue'

export default {
  components: {
    AmsThumbnail
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    per_page_setting: {
      Type: Number
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      ams_type: 'collection-images',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'CollectionImageCreateScreen',
      ams_fields: [
       { 
          key: 'attributes.is-reviewed',
          label: 'Is Reviewed',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
       { 
          key: 'attributes.is-of-interest',
          label: 'Is Of Interest',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
      ],
      describe_belongs_to: [
        {
          prepend: ' of ',
          type: 'collections',
          description_attr: 'name',
          append: ''
        }
      ]
    }
  }
}
</script>